<template>
  <CModal
    :title="$t('create_account')"
    size="xl"
    color="info"
    :closeOnBackdrop="false"
    :show.sync="modal.show"
    @update:show="showUpdate"
  >
    <CRow>
      <CCol col="12" sm="12">
        <CInput
          :label="$t('name')"
          :placeholder="$t('name')"
          :horizontal="{ label: 'col-sm-3', input: 'col-sm-9'}"
          v-model="formData.name"
          :isValid="valid_formData_name"
        />
      </CCol>
      <CCol col="12" sm="12">
        <CInput
          :label="$t('email')"
          type="email"
          :placeholder="$t('email')"
          :horizontal="{ label: 'col-sm-3', input: 'col-sm-9'}"
          v-model="formData.email"
          :isValid="valid_formData_email"
        />
      </CCol>
      <CCol col="12" sm="12">
        <CInput
          :label="$t('password')"
          type="password"
          :placeholder="$t('password')"
          :description="$t('password_min_msg')"
          :horizontal="{ label: 'col-sm-3', input: 'col-sm-9'}"
          v-model="formData.password"
          :isValid="valid_formData_password"
        />
      </CCol>
      <CCol col="12" sm="12">
        <div class="form-group form-row">
          <label class="col-form-label col-sm-3">
            {{ $t('roles') }}
          </label>
          <div class="col-sm-9">
            <multiselect
              v-model="formData.rolesSelect"
              :placeholder="$t('roles')"
              label="label"
              track-by="value"
              :options="rolesOptions"
              :multiple="true"
              :show-labels="false"
              :close-on-select="false"
              :max-height="1000"
            />
          </div>
        </div>
      </CCol>
      <CCol col="12" sm="12">
        <CSelect
          :label="$t('enable')"
          :options="enabledOptions"
          :horizontal="{ label: 'col-sm-3', input: 'col-sm-9'}"
          :value.sync="formData.enabled"
          :isValid="valid_formData_enabled"
        />
      </CCol>
    </CRow>
    <CButton slot="footer" color="primary" block @click="submit()">{{ $t('save') }}</CButton>
  </CModal>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  name: 'CreateAdminModal',
  components: {
    Multiselect
  },
  props: {
    data: {
      type: Object,
      required: true,
      default: function () {
        return {}
      }
    },
    show: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data () {
    return {
      modal: {
        data: this.data,
        show: this.show
      },
      rolesOptions: [{ value: 'root', label: 'ROOT' }],
      enabledOptions: [
        { value: 1, label: this.$t('enable'), color: 'success' },
        { value: 0, label: this.$t('disable'), color: 'secondary' }
      ],
      formData: {},
    }
  },
  watch: {
    data (e) {
      this.modal.data = e
    },
    show (e) {
      this.modal.show = e
      if (e) {
        this.formData = { name: '', email: '', password: '', rolesSelect: [], enabled: 1 }
      }
    }
  },
  computed: {
    valid_formData_name () {
      return this.formData.name ? true : false
    },
    valid_formData_email () {
      return /^([a-z0-9_.-]+)@([\da-z.-]+)\.([a-z.]{2,6})$/.test(this.formData.email) ? true : false
    },
    valid_formData_password () {
      return this.formData.password && this.formData.password.length >= 8 ? true : false
    },
    valid_formData_enabled () {
      return this.formData.enabled === 0 || this.formData.enabled === 1 ? true : false
    },
    valid_submit () {
      return this.valid_formData_name && this.valid_formData_email && this.valid_formData_password && this.valid_formData_enabled
    }
  },
  mounted: function () {
    this.loadRolesOptions()
  },
  methods: {
    showUpdate (show, e) {
      this.$emit('showUpdate', show, e)
    },
    formSubmit (submit, e) {
      this.$emit('formSubmit', submit, e)
    },
    loadRolesOptions () {
      let r = this.$router.options.routes[0].children
      for (let i in r) {
        if (r[i].meta && r[i].meta.role && r[i].meta.role !== 'root') {
          this.rolesOptions.push({ value: r[i].meta.role, label: r[i].name })
        }
        if (r[i].children && r[i].children.length > 0) {
          for (let x in r[i].children) {
            if (r[i].children[x].meta && r[i].children[x].meta.role && r[i].children[x].meta.role !== 'root') {
              this.rolesOptions.push({ value: r[i].children[x].meta.role, label: r[i].name + ' / ' + r[i].children[x].name })
            }
          }
        }
      }
    },
    submit () {
      if (this.valid_submit) {
        const loader = this.$loading.show()
        this.$store.dispatch('storeAdmin', this.$_.extend(this.$_.clone(this.formData), { roles: this.$_.pluck(this.formData.rolesSelect, 'value') })).then(res => {
          this.formSubmit(true)
          this.modal.show = false
          this.showUpdate(false)
          this.$swal('Success', this.$t('created_successfully'), 'success')
          loader.hide()
        }).catch(e => {
          this.$swal('Error', e.message ? e.message : e, 'error')
          loader.hide()
        })
      } else {
        this.$swal('Warning', this.$t('required_fields_cannot_be_empty'), 'warning')
      }
    },
  },
  beforeDestroy: function () {
  },
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
